var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M442.039,350.945c-3.803,0-7.588-1.572-10.298-4.652c-5.006-5.686-4.454-14.352,1.23-19.356 c35.591-31.334,51.6-60.346,51.6-70.937c0-29.903-97.241-143.058-228.572-143.058c-7.574,0-13.714-6.141-13.714-13.714 c0-7.573,6.14-13.714,13.714-13.714c82.674,0,148.09,41.161,179.727,65.696C481.347,186.59,512,228.702,512,255.999 c0,23.025-23.907,58.95-60.904,91.524C448.49,349.819,445.258,350.945,442.039,350.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M256.001,426.487c-82.46,0-148.017-41.51-179.753-66.254C31.354,325.236,0,282.373,0,256.001 c0-21.928,20.949-54.96,54.672-86.208c5.558-5.147,14.234-4.819,19.381,0.738c5.148,5.556,4.818,14.233-0.738,19.381 c-33.43,30.974-45.887,56.975-45.887,66.089c0,13.163,22.826,49.192,65.682,82.603c28.96,22.578,88.633,60.455,162.89,60.455 c7.574,0,13.714,6.141,13.714,13.714C269.715,420.346,263.574,426.487,256.001,426.487z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M256.001,99.392c-86.492,0-156.608,70.116-156.608,156.608s70.116,156.608,156.608,156.608 s156.608-70.114,156.608-156.606C412.608,169.507,342.493,99.392,256.001,99.392z M256.001,334.796 c-43.518,0-78.797-35.279-78.797-78.796c0-43.518,35.279-78.797,78.797-78.797s78.797,35.279,78.797,78.797 C334.796,299.517,299.518,334.796,256.001,334.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M256.001,426.323c-93.916,0-170.322-76.406-170.322-170.322S162.084,85.677,256.001,85.677 s170.322,76.406,170.322,170.323S349.916,426.323,256.001,426.323z M256.001,113.106c-78.793,0-142.893,64.102-142.893,142.893 s64.101,142.895,142.893,142.895s142.893-64.102,142.893-142.893S334.792,113.106,256.001,113.106z M256.001,348.51 c-51.01,0-92.511-41.499-92.511-92.51s41.499-92.511,92.511-92.511s92.511,41.501,92.511,92.511S307.011,348.51,256.001,348.51z M256.001,190.917c-35.886,0-65.083,29.196-65.083,65.083s29.196,65.081,65.083,65.081s65.083-29.195,65.083-65.081 S291.885,190.917,256.001,190.917z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CFF09E"
    },
    cx: 310.862,
    cy: 210.597,
    r: 42.514
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M310.858,266.829c-31.004,0-56.229-25.225-56.229-56.229s25.225-56.229,56.229-56.229 s56.229,25.225,56.229,56.229S341.862,266.829,310.858,266.829z M310.858,181.801c-15.881,0-28.8,12.92-28.8,28.8 s12.919,28.8,28.8,28.8s28.8-12.92,28.8-28.8S326.738,181.801,310.858,181.801z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAll);
export default __webpack_public_path__ + "static/media/show-all.af938d2b3662d7db8ac21f50f8d98eaa.svg";
export { ForwardRef as ReactComponent };